module.exports = __webpack_public_path__ + "static/media/logo2.17fda966.png";